import React from 'react'
import classnames from 'classnames'

// eslint-disable-next-line import/no-unresolved
import { useFocusTrap } from 'react-use-focus-trap'

import { useConsentConfig } from 'components/ConsentConfigProvider'

import ConsentPromptContent from '../ConsentPromptContent'

import Styles from './styles.scss'

import useScrollToAccept from './hooks/useScrollToAccept'


export default function Banner() {
  const [trapRef] = useFocusTrap()

  const consentConfig = useConsentConfig()

  useScrollToAccept({
    isEnabled: consentConfig.enable_consent_by_scroll,
  })

  const rootClassName = classnames(Styles[`termly-${ consentConfig.display_style }`],
                                   Styles[consentConfig.size],
                                   Styles[consentConfig.position])

  return (
    <div
      ref={ trapRef }
    >
      <ConsentPromptContent
        className={ rootClassName }
        stylesOverrides={ Styles }
      />
    </div>
  )
}

